import React from "react";
import { Box, Typography, FormControlLabel, Switch } from "@mui/material";

const DiveSharedOption = ({ createSharedDive, setCreateSharedDive }) => {
  return (
    <Box sx={{ width: "100%" }}>
      <FormControlLabel
        control={
          <Switch
            checked={createSharedDive}
            onChange={(event) => setCreateSharedDive(event.target.checked)}
            name="createSharedDive"
          />
        }
        label="Create Shared Dive QR Code"
      />

      {createSharedDive && (
        <Typography variant="body2" sx={{ ml: 3, mt: 1, maxWidth: "100%" }}>
          A Shared Dive QR code allows divers that have the code to associate
          their dive log entry with this one, creating a comprehensive view into
          the team's diving experiences on this dive.
        </Typography>
      )}
    </Box>
  );
};

export default DiveSharedOption;
